import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"

import { useUploadStream, sizeConvert } from "Utils"
import Alert from "./alert.jsx"
import Loading from "../Loading"

function Upload(props) {
  const { onComplete } = props
  
  const projectUid = useSelector(state => state.project.projectUid)

  const [meta, progress] = useUploadStream(props.file, projectUid)
  
  useEffect(() => {
    if(progress.status === "finished" && meta.uid && onComplete) onComplete(meta)
  }, [progress.status, meta, onComplete])

  const classes = styles()

  return (
    <Alert
      open={progress.status === "started"}
      title="File upload"
      text={`${meta.name}.${meta.ext} (${sizeConvert(progress.total)})`}
      content={
        <Loading
          className={classes.loading}
          type="linear"
          determinate
          value={progress.percent}
          label={`${progress.percent}%`}
        />
      }
    />
  )
}

const styles = makeStyles(theme => ({
  loading: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginLeft: 35
  }
}))

export default Upload